import React, { useState } from 'react'
import annadaan from './assets/annadaan.webp'
import vidyaDaan from './assets/vidyaDaan.webp'
import image from '../../Blogs/assets/0O4A6439.webp'
import style from './daans.module.css'

const Daans = () => {
    const TypesOfDaans = [
        {
            id: 1,
            h2: "ANADAAN",
            h3: "FEED THE HUNGRY",
            image: annadaan,
            alt: "annadaan",
            description: "Annadaan is the act of offering sanctified food (prasadam) that nourishes both body and spirit. Every meal we serve carries compassion, dignity, and spiritual blessings. Join us in serving thousands of free meals and help spread care, dignity, and spiritual nourishment."
        },
        {
            id: 2,
            h2: "VIDYADAAN",
            h3: "ENLIGHTEN EVERY MIND",
            image: vidyaDaan,
            alt: "vidyaDaan",
            description: "Vidyadaan shares life-changing spiritual wisdom that nurtures values, builds confidence, and inspires purpose in young hearts. By Vedic teachings to children, teenagers, and youth, we empower them to make wise choices and lead meaningful lives. Support us in distributing spiritual literature, empowering minds, and transforming communities with divine knowledge."
        },
        {
            id: 3,
            h2: "SEVADAAN",
            h3: "SERVING WITH DEVOTION",
            image: image,
            alt: "SEVADAAN",
            description: "Sevadaan is the sacred opportunity to support and serve deity worship, daily aarti, abhishek, bhoga offerings, grand festivals. Your seva sustains temple worship and inspires countless souls in their spiritual journey. Contribute today to serve the Lord and spiritual wisdom."
        }
    ]

    const [currentIndex, setCurrentIndex] = useState(0)

    const prevSlide = () => {
        setCurrentIndex((prev) => (prev === 0 ? TypesOfDaans.length - 1 : prev - 1))
    }

    const nextSlide = () => {
        setCurrentIndex((prev) => (prev === TypesOfDaans.length - 1 ? 0 : prev + 1))
    }

    return (
        <>
            <div className={style.daanSection}>
                <button className={style.arrow} onClick={prevSlide}>❮</button>

                <div className={style.cardContainer}>
                    {TypesOfDaans.map((item, index) => (
                        <div
                            className={`${style.card} ${index === currentIndex ? style.active : style.hidden}`}
                            key={item.id}
                        >
                            <h2>{item.h2}</h2>
                            <h3>{item.h3}</h3>
                            <p>{item.description}</p>
                            <img src={item.image} alt={item.alt} />
                        </div>
                    ))}
                </div>

                <button className={style.arrow} onClick={nextSlide}>❯</button>
            </div>

            <div className={style.dots}>
                {TypesOfDaans.map((_, idx) => (
                    <span
                        key={idx}
                        className={`${style.dot} ${idx === currentIndex ? style.activeDot : ''}`}
                        onClick={() => setCurrentIndex(idx)}
                    ></span>
                ))}
            </div>

            <div className={style.formHeading}>
                <h2>REQUESTING YOUR CONTRIBUTION</h2>
                <p>Your generous contributions empower us...</p>
            </div>
        </>
    )
}

export default Daans
